import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade21,
  blueColor04,
  greyColor14,
  redColor,
  whiteColor,
  yellowColor,
} from "../../../configs/styles/muiThemes";

const ActionButtons = ({
  goBack,
  categoryError,
  currentPage,
  handleQuickUpdate,
  handleQuickOndcSpecUpdate,
  handleQuickOndcParamsUpdate,
  handleDeleteClick,
  productList,
  isDisabled,
  selectedProdGroup,
  isDynamicSpecEmpty,
  ondcSpecError,
  deleteProductLoader,
  selectedRowCount,
  selectedOndcSpecCount,
  getNextButtonText,
  isLoading,
  handleNext,
  ondcSpecLoader,
  updateLoader,
  errorMsg,
  hideNextBtn,
}) => {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="center"
      gap={2}
      mt={2}
    >
      {currentPage !== "provide-sku" && currentPage !== "assign-category" && (
        <Button
          variant="contained"
          sx={styles.backBtn}
          disableElevation
          onClick={goBack}
        >
          BACK
        </Button>
      )}

      {(currentPage === "assign-category" || currentPage === "product-info") &&
        productList?.length > 0 && (
          <Box>
            <Button
              variant="contained"
              sx={{ ...styles.backBtn, ...styles.assignBtn }}
              disableElevation
              onClick={handleQuickUpdate}
              disabled={productList?.length === 0 || isDisabled}
            >
              {currentPage === "assign-category"
                ? "ASSIGN CATEGORY"
                : "QUICK UPDATE"}
            </Button>

            {categoryError && (
              <Typography
                fontSize={10.5}
                fontWeight={500}
                color={redColor}
                mt={1}
              >
                {categoryError}
              </Typography>
            )}
          </Box>
        )}

      {currentPage === "ondc" && (
        <Box>
          <Button
            variant="contained"
            sx={{ ...styles.backBtn, ...styles.assignBtn }}
            disableElevation
            onClick={handleQuickOndcParamsUpdate}
            disabled={isDisabled || isLoading}
          >
            QUICK UPDATE
          </Button>

          {ondcSpecError && (
            <Typography
              fontSize={10.5}
              fontWeight={500}
              color={redColor}
              mt={1}
            >
              {ondcSpecError}
            </Typography>
          )}
        </Box>
      )}

      {currentPage === "addOndcSpecs" &&
        selectedProdGroup &&
        !isDynamicSpecEmpty && (
          <Box>
            <Button
              variant="contained"
              sx={{ ...styles.backBtn, ...styles.assignBtn }}
              disableElevation
              onClick={handleQuickOndcSpecUpdate}
              disabled={
                selectedProdGroup?.products?.length === 0 ||
                !selectedProdGroup ||
                isDisabled ||
                isLoading
              }
            >
              QUICK UPDATE FOR SPECS
            </Button>

            {ondcSpecError && (
              <Typography
                fontSize={10.5}
                fontWeight={500}
                color={redColor}
                mt={1}
              >
                {ondcSpecError}
              </Typography>
            )}
          </Box>
        )}

      {/* {currentPage !== "provide-sku" &&
        currentPage !== "upload" &&
        currentPage !== "ondcSpecGroup" &&
        currentPage !== "addOndcSpecs" &&
        productList?.length > 0 && (
          <Button
            variant="contained"
            disableElevation
            sx={{ ...styles.backBtn, ...styles.deleteBtn }}
            onClick={handleDeleteClick}
            startIcon={
              deleteProductLoader ? (
                <CircularProgress color="inherit" size={14} />
              ) : null
            }
            disabled={selectedRowCount === 0 || isDisabled}
          >
            DELETE{" "}
            {selectedRowCount === 1
              ? `${selectedRowCount} Row`
              : `${selectedRowCount} Rows`}
          </Button>
        )} */}

      {!hideNextBtn && (
        <Stack>
          <Button
            variant="contained"
            sx={styles.nextBtn(isLoading)}
            disableElevation
            onClick={handleNext}
            disabled={
              ondcSpecLoader ||
              updateLoader ||
              isDisabled ||
              isLoading ||
              (selectedRowCount === 0 &&
                (currentPage === "review" ||
                  currentPage === "ondc" ||
                  currentPage === "assign-category"))
              // (selectedRowCount === 0 && currentPage === "review")
            }
            startIcon={
              // ondcSpecLoader ||
              // isLoading ||
              // updateLoader ||
              isLoading && (
                <CircularProgress
                  sx={{ color: greyColor14, opacity: 0.5 }}
                  size={16}
                />
              )
            }
          >
            {getNextButtonText()}
          </Button>

          {errorMsg && (
            <Typography
              fontSize={10.5}
              fontWeight={500}
              color={redColor}
              mt={1}
            >
              {errorMsg}
            </Typography>
          )}
        </Stack>
      )}

      {/* {currentPage !== "provide-sku" &&
      currentPage !== "upload" &&
      productList?.length === 0 ? (
        <></>
      ) : (
        <Stack>
          <Box>
            <Button
              variant="contained"
              sx={styles.nextBtn(isLoading)}
              disableElevation
              onClick={handleNext}
              disabled={
                ondcSpecLoader ||
                updateLoader ||
                isDisabled ||
                isLoading ||
                (selectedRowCount === 0 &&
                  (currentPage === "review" ||
                    currentPage === "ondc" ||
                    currentPage === "assign-category"))
                // (selectedRowCount === 0 && currentPage === "review")
              }
              startIcon={
                ondcSpecLoader ||
                isLoading ||
                (updateLoader && (
                  <CircularProgress
                    sx={{ color: greyColor14, opacity: 0.5 }}
                    size={16}
                  />
                ))
              }
            >
              {getNextButtonText()}
            </Button>
          </Box>

          {isError && (
            <Typography
              fontSize={10.5}
              fontWeight={500}
              color={redColor}
              mt={1}
            >
              {isError}
            </Typography>
          )}
        </Stack>
      )}

      {currentPage === "addOndcSpecs" && (
        <Button
          variant="contained"
          sx={{ ...styles.backBtn, ...styles.assignBtn }}
          disableElevation
          onClick={() => {
            ondcSpecSaveAndExit(selectedProdGroup);
          }}
          disabled={
            isLoading ||
            selectedProdGroup?.products?.length === 0 ||
            !selectedProdGroup ||
            isDisabled
          }
          startIcon={
            ondcSpecLoader ||
            isLoading ||
            (updateLoader && (
              <CircularProgress
                sx={{ color: greyColor14, opacity: 0.5 }}
                size={16}
              />
            ))
          }
        >
          SAVE & EXIT
        </Button>
      )} */}
    </Box>
  );
};

export default ActionButtons;

const styles = {
  backBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: blackShade21,
    backgroundColor: whiteColor,
    border: `1px solid ${blackShade21}`,
    padding: "7px 30px",
    borderRadius: "5px",
    "&:hover": {
      color: whiteColor,
      backgroundColor: blackShade21,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },

  assignBtn: {
    color: blueColor04,
    border: `1px solid ${blueColor04}`,
    backgroundColor: whiteColor,
    "&:hover": {
      color: whiteColor,
      backgroundColor: blueColor04,
    },
  },

  deleteBtn: {
    color: redColor,
    border: `1px solid ${redColor}`,
    backgroundColor: whiteColor,
    "&:hover": {
      color: whiteColor,
      backgroundColor: redColor,
    },
  },

  nextBtn: (isDisabled) => ({
    fontSize: 13,
    fontWeight: 500,
    color: blackColor,
    backgroundColor: yellowColor,
    border: isDisabled ? "none" : `1px solid ${yellowColor}`,
    padding: "7px 30px",
    borderRadius: "7px",
    "&:hover": {
      color: yellowColor,
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  }),
};
